import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/store'
import LocalAuthService from '@/services/LocalAuthService'
import Home from '../views/Home.vue'
import Error from '../views/Error.vue'
import Login from '../views/Login.vue'
import LoginEmailAddress from '../views/LoginEmailAddress.vue'
import LoginContactType from '../views/LoginContactType.vue'
import LoginVerify from '../views/LoginVerify.vue'
import History from '../components/History.vue'
import HistoryDetailsDialog from '../components/HistoryDetailsDialog'
import SendDialog from '../components/SendDialog.vue'
import Users from '../components/Users.vue'
import UserEdit from '../components/EditUserDialog.vue'
import EmailOptInHelp from '@/views/EmailOptInHelp.vue'
import Settings from '@/components/Settings.vue'
import Logger from '@/services/Logger'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: { name: 'History' }
  },
  {
    path: '/opt-in',
    name: 'EmailOptInHelp',
    component: EmailOptInHelp,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/alerts',
    name: 'History',
    component: History,
    children: [
      {
        name: 'Send',
        path: 'send',
        props: true,
        component: SendDialog
      },
      {
        name: 'HistoryDetails',
        path: ':historyId',
        props: true,
        component: HistoryDetailsDialog
      }
    ]
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    children: [
      {
        name: 'UserEdit',
        path: ':userId',
        props: true,
        component: UserEdit
      }
    ]
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    name: 'Error',
    path: '/error/:errorCode',
    component: Error,
    meta: {
      requiresAuth: false
    },
    props: true
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    redirect: { name: 'LoginEmailAddress' },
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: 'email',
        name: 'LoginEmailAddress',
        component: LoginEmailAddress,
        props: true,
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'contact',
        name: 'LoginContactType',
        component: LoginContactType,
        props: true,
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'verify',
        name: 'LoginVerify',
        component: LoginVerify,
        props: true,
        meta: {
          requiresAuth: false
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'Error') {
    store.commit('SET_PREVIOUS_ROUTE', from)
  }

  function redirectToLogin (from) {
    store.dispatch('auth/logout')
    store.dispatch('snackbar/showSnackbar', { message: 'Your session has expired. Please log in again.' })
    const to = LocalAuthService.getLoginRoute(from)
    next(to)
  }

  if (typeof to.meta === 'undefined' || typeof to.meta.requiresAuth === 'undefined' || to.meta.requiresAuth === true) {
    let loginPromise = null

    if (!store.state.auth.isLoggedIn) {
      loginPromise = store.dispatch('auth/tryRestoreLogin')
    } else {
      loginPromise = store.dispatch('auth/verifyLogin')
    }

    loginPromise
      .then(result => {
        if (result !== true) {
          redirectToLogin(from)
        } else {
          next()
        }
      })
      .catch(error => {
        Logger.error(`Verifying auth token failed: ${error}`)
        redirectToLogin(from)
      })
  } else {
    next()
  }
})

export default router
